var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelay = function SvgDelay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#delay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.833 10.333c0-.604.49-1.094 1.094-1.094h50.046c.604 0 1.094.49 1.094 1.094v44.705c0 .604-.49 1.093-1.094 1.093H3.927c-.604 0-1.094-.49-1.094-1.093V10.333Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.576,
    y: 25.179,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.576,
    y: 34.852,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.576,
    y: 44.524,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.216,
    y: 25.179,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.216,
    y: 34.852,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.216,
    y: 44.524,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.857,
    y: 25.179,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.857,
    y: 34.852,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.857,
    y: 44.524,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.498,
    y: 25.179,
    width: 4.836,
    height: 4.836,
    rx: 1,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.498,
    y: 34.852,
    width: 4.836,
    height: 4.836,
    rx: 0.967,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.498,
    y: 44.524,
    width: 4.836,
    height: 4.836,
    rx: 0.967,
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M2.833 18.974h52.234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.831 48.603v5.108a2 2 0 0 0 2 2h48.245a2 2 0 0 0 2-2V11.239a2 2 0 0 0-2-2H4.83a2 2 0 0 0-2 2v26.977",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.937 7.767a2.502 2.502 0 0 1 5.003 0v3.87a2.502 2.502 0 1 1-5.003 0v-3.87ZM26.452 7.767a2.502 2.502 0 0 1 5.004 0v3.87a2.502 2.502 0 1 1-5.004 0v-3.87ZM41.28 7.767a2.502 2.502 0 1 1 5.004 0v3.87a2.502 2.502 0 0 1-5.004 0v-3.87Z",
    fill: "#D9D9D9",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.432,
    cy: 45.119,
    transform: "rotate(-15.42 52.432 45.119)",
    fill: "#EAFFE6",
    stroke: "#000",
    strokeWidth: 0.8,
    r: 17.403
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.322 40.542V33.64c0-.076.062-.137.137-.137l2.112.002c.076 0 .137.062.137.137l-.008 5.976c0 .093.092.16.18.13l6.729-2.243c.088-.03.18.036.18.13v1.41c0 .059-.038.111-.093.13l-6.903 2.349a.137.137 0 0 0-.093.13v1.554c0 .095.093.16.182.13l6.749-2.383a.137.137 0 0 1 .182.13v1.456c0 .058-.037.11-.092.13l-6.929 2.397a.137.137 0 0 0-.092.13v7.647c0 .076.062.137.137.135 4.392-.09 7.831-4.489 7.91-8.39a.138.138 0 0 1 .138-.136h2.43c.079 0 .141.067.137.145-.478 8.088-7.402 11.99-12.995 10.709a.135.135 0 0 1-.105-.132l-.059-9.172a.137.137 0 0 0-.18-.129l-3.964 1.34a.137.137 0 0 1-.18-.127l-.025-1.327a.137.137 0 0 1 .09-.131l4.197-1.487a.137.137 0 0 0 .091-.129v-1.48a.137.137 0 0 0-.18-.13l-4.05 1.34a.137.137 0 0 1-.18-.129v-1.356c0-.058.037-.11.092-.13l4.226-1.457a.137.137 0 0 0 .092-.129Z",
    fill: "#58B847",
    stroke: "#000",
    strokeWidth: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.833 .5)",
    d: "M0 0h80v65H0z"
  })))));
};
export default SvgDelay;